import React from "react";
import styled from "styled-components";

export const PortfolioCountColumn = styled.div`
    display: flex;
    flex-shrink: 0;
    justify-content: flex-end;
    text-transform: none;
    font-size: 11px;
    font-weight: normal;
    padding-right: 6px;
`;

const PortfolioCountCell = styled(PortfolioCountColumn)`
    flex-direction: column;
    align-items: flex-end;
`;

const ClosedCount = styled.div`
`;

export const PortfolioCount = ({portfolios}) => {
    const all = portfolios.length;
    const closed = portfolios.filter(p => !p.open).length;

    return <PortfolioCountCell>
        <div className={"t-portfolio-count"}>{all}</div>
        {closed > 0 ? <ClosedCount className={"t-portfolio-count-closed"}>{`(${closed} closed)`}</ClosedCount> : null}
    </PortfolioCountCell>;
};

